import React from 'react';
import { BsArchive, BsCheck2Circle, BsFileText, BsTrash } from 'react-icons/bs';

import ConfirmActionWarningModal from '../../../../../components/ConfirmActionWarningModal';
import StackedButtonGroup from '../../../../../components/Modal/ModalButtonGroups/StackedButtonGroup';
import { inAppText } from '../../../../../constants/inAppText';
import { hideModal, showModal, updateModalOptions } from '../../../../../redux/modules/modal';
import { showTray } from '../../../../../redux/modules/tray';
import { showDontAskAgainModal } from '../../../../../utils/askAgainModalUtil';
import { confirmArchiveWithProcoreWarning, loadProcoreDeleteWarning } from '../../../../../utils/procoreWarningModalUtil';
import { createToast } from '../../../../../utils/toastUtil';
import RequirementInfoTray from '../../../../JobDetailsPage/components/RequirementInfoTray';

import RecordWatcherIconButtonContainer from './RecordWatcherIconButtonContainer';

const handleDeleteRecord = async ({ e, dispatch, deleteInsuranceRequirement }) => {
  e.preventDefault();
  e.stopPropagation();
  e.persist();

  const { procoreWarning, commit } = await loadProcoreDeleteWarning(dispatch, 'record');

  dispatch(showModal(
    () => (
      <ConfirmActionWarningModal
        description={inAppText.projectDetailsPage.recordOptions.deleteRecordMessage}
        procoreWarning={procoreWarning}
      />
    ),
    {
      title: 'Delete Record?',
      size: 'md',
      buttons: {
        component: StackedButtonGroup,
        primaryButtonOptions: {
          label: 'Delete',
          isDisabled: true,
          onClick: async () => {
            commit();
            dispatch(updateModalOptions({ buttons: { primaryButtonOptions: { isLoading: true } } }));
            deleteInsuranceRequirement();
            dispatch(hideModal());
          }
        }
      }
    }
  ));
};

export const activeMenuOptions = (record, currentUser) => ([
  {
    label: 'Record Information',
    icon: BsFileText,
    id: 'recordInformation',
    handler: ({
      e,
      dispatch,
      updateInsuranceRequirement
    }) => {
      e.preventDefault();
      e.stopPropagation();

      const onFormSubmit = async (requirement, requirementData) => {
        updateInsuranceRequirement(requirementData);
      };

      dispatch(showTray(
        () => <RequirementInfoTray requirement={record} onFormSubmit={onFormSubmit} />,
        {
          title: 'Record Information',
          titleComponent: () => (
            <RecordWatcherIconButtonContainer
              companyId={record.companyId}
              currentUser={currentUser}
              departmentId={record.job?.department?.departmentId}
              insuredId={record.insuredId}
              recordId={record.requirementId}
            />
          )
        }
      ));
    }
  },
  {
    label: 'Archive Record',
    icon: BsArchive,
    id: 'archiveRecord',
    handler: ({
      e,
      dispatch,
      archiveInsuranceRequirement
    }) => {
      e.preventDefault();
      e.stopPropagation();
      e.persist();

      const cookieId = 'hideArchiveRecordModal';

      const archiveRecord = async () => {
        dispatch(hideModal());
        createToast({
          title: 'Archiving Record...',
          status: 'info',
          duration: 10000
        });

        archiveInsuranceRequirement();

        const pathWithoutRecords = window.location.pathname.replace(/\/records\/\d+$/, '');
        window.history.replaceState(null, '', pathWithoutRecords);
      };

      confirmArchiveWithProcoreWarning({
        dispatch,
        scope: 'record',
        cookieId,
        description: inAppText.projectDetailsPage.recordOptions.archiveRecordMessage,
        onClick: archiveRecord,
        title: 'Archive Record?'
      });
    }
  },
  {
    label: 'Delete Record',
    icon: BsTrash,
    id: 'deleteRecord',
    handler: handleDeleteRecord
  }
]);

export const archivedMenuOptions = disableReactivateRecord => ([
  {
    label: 'Reactivate Record',
    icon: BsCheck2Circle,
    id: 'reactivateRecord',
    isDisabled: disableReactivateRecord,
    tooltip: disableReactivateRecord ? 'Related Project Or Insured Must Be Active' : null,
    handler: ({ e, dispatch, insured, reactivateInsuranceRequirement }) => {
      e.preventDefault();
      e.stopPropagation();
      e.persist();

      const cookieId = 'hideActivateRecordModal';

      const activateRecord = () => {
        dispatch(hideModal());
        reactivateInsuranceRequirement();
      };

      showDontAskAgainModal({
        dispatch,
        cookieId,
        description: inAppText.projectDetailsPage.recordOptions.reactivateRecordMessage,
        onClick: activateRecord,
        title: 'Reactivate Record?'
      });
    }
  },
  {
    label: 'Delete Record',
    icon: BsTrash,
    id: 'deleteInsured',
    handler: handleDeleteRecord
  }
]);
